/** @jsx jsx */
import type { PropsWithChildren, FC } from 'react';
import { jsx, cssMap } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const ReplyCommentWrapper: FC<PropsWithChildren> = ({ children }) => (
	<section
		data-testid="issue-view-activity-comment.comment-reply-wrapper.reply-container"
		css={[sectionStyles.container]}
	>
		{children}
	</section>
);
const sectionStyles = cssMap({
	container: {
		// 32 px for the padding given to the parent container (24+8)
		maxWidth: 'calc(100% - 32px)',
		position: 'relative',
		'--commentLineWidth': '1px',
		'--commentLineColor': token('color.background.accent.gray.subtler'),
		// 8px padding + 0.5px (to center align line of 1px) + 18px center align avatar = 26.5px
		'--commentInlineStart': 'calc(-26px - var(--commentLineWidth)/2)',
		'--commentSpacing': token('space.150'),
		'--childTailWidth': token('space.200'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& [data-testid="issue-view-activity-comment.comment-reply-editor.reply-editor"] [data-vc="profilecard-wrapper"], & > [data-testid="issue-view-activity-comment.comment-show-more-replies.container"], & [data-testid="issue-view-activity-comment.comment-reply-editor.reply-editor"] [data-vc="profilecard-wrapper-ssr"]':
			{
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
				'&:has(img), & > [data-testid="issue-view-activity-comment.comment-show-more-replies.empty-container"]':
					{
						position: 'relative',
						'&::after': {
							boxSizing: 'border-box',
							content: '',
							position: 'absolute',
							insetInlineStart: 'var(--commentInlineStart)',
							top: 'calc(-50% - var(--commentLineWidth)/2)',
							width: 'var(--childTailWidth)',
							borderInlineStart: 'var(--commentLineWidth) solid var(--commentLineColor)',
							borderBottom: 'var(--commentLineWidth) solid var(--commentLineColor)',
							backgroundColor: token('color.background.neutral.subtle'),
							borderEndStartRadius: token('space.100'),
							height: '100%',
						},
					},
			},

		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
		'&:not(:has([data-testid="issue-view-activity-comment.comment-reply-editor.reply-editor"]))': {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
			'&:first-child:not(:last-child)': {
				// :not(:last-child): Ensures that this child is not the last one, implying there must be at least one more sibling.
				position: 'relative',
				'&::before': {
					content: '',
					position: 'absolute',
					height: 'calc(100% - var(--commentSpacing))',
					top: '12px',
					width: 'var(--commentLineWidth)',
					insetInlineStart: 'var(--commentInlineStart)',
					backgroundColor: 'var(--commentLineColor)',
				},
			},
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		'&:not(:first-child):not(:last-child)': {
			position: 'relative',
			'&::before': {
				content: '',
				position: 'absolute',
				// -8px is given because each child comment has margin of 8px
				bottom: token('space.0'),
				width: 'var(--commentLineWidth)',
				insetInlineStart: 'var(--commentInlineStart)',
				backgroundColor: 'var(--commentLineColor)',
				height: 'calc(100% - var(--commentSpacing))',
				top: '12px',
			},
		},
	},
});

export default ReplyCommentWrapper;
